import { render, staticRenderFns } from "./CatalogsEdit.vue?vue&type=template&id=74a2f2a0&lang=pug&"
import script from "./CatalogsEdit.vue?vue&type=script&lang=ts&"
export * from "./CatalogsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports